import _assert_this_initialized from "@swc/helpers/src/_assert_this_initialized.mjs";
import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { isMissingValue } from "../api/Missing.js";
import { MissingFormatRange } from "./internal/MissingFormat.js";
import { TemporalUtils } from "./internal/TemporalUtils.js";
var keyFromTimeZone = function(timeZone) {
    return timeZone.toLowerCase();
};
/**
 * Proxy for {@link Intl.DateTimeFormat} that formats `null` and `undefined` as missing values.
 * It also adds support for {@link Temporal.Instant} and {@link Temporal.ZonedDateTime},
 * and will respect the offset in specific values if present.
 */ export var DateTimeMissingFormat = /*#__PURE__*/ function(MissingFormatRange) {
    "use strict";
    _inherits(DateTimeMissingFormat, MissingFormatRange);
    var _super = _create_super(DateTimeMissingFormat);
    function DateTimeMissingFormat(localesOrFormat, options) {
        _class_call_check(this, DateTimeMissingFormat);
        var _this;
        _this = _super.call(this, _instanceof(localesOrFormat, Intl.DateTimeFormat) ? localesOrFormat : new Intl.DateTimeFormat(localesOrFormat, options), options);
        Object.defineProperty(_assert_this_initialized(_this), "tzMap", {
            value: new Map()
        });
        _this.tzMap.set(keyFromTimeZone(_this.wrapped.resolvedOptions().timeZone), _this.wrapped);
        return _this;
    }
    var _proto = DateTimeMissingFormat.prototype;
    _proto.format = function format(value) {
        if (isMissingValue(value)) {
            return this.missing;
        }
        return this.zoned(value).format(TemporalUtils.toDate(value));
    };
    _proto.formatToParts = function formatToParts(value) {
        if (isMissingValue(value)) {
            return [
                {
                    type: "missing",
                    value: this.missing
                }
            ];
        }
        return this.zoned(value).formatToParts(TemporalUtils.toDate(value));
    };
    _proto.formatRange = function formatRange(start, end) {
        var fmt = this.zoned(start);
        return fmt.formatRange(TemporalUtils.toDate(start), TemporalUtils.toDate(end));
    };
    _proto.formatRangeToParts = function formatRangeToParts(start, end) {
        var fmt = this.zoned(start);
        return fmt.formatRangeToParts(TemporalUtils.toDate(start), TemporalUtils.toDate(end));
    };
    _proto.zoned = function zoned(value) {
        // The timeZone is assumed to be a valid IANA time zone ID,
        // since the potential sources (Dayjs, Temporal) are expected to have validated it.
        var timeZone = TemporalUtils.timeZoneFromValue(value);
        if (!timeZone) {
            return this.wrapped;
        }
        var key = keyFromTimeZone(timeZone);
        var zonedFormatter = this.tzMap.get(key);
        if (!zonedFormatter) {
            var options = this.wrapped.resolvedOptions();
            // Should timeZone turn out to be invalid, Intl.DateTimeFormat will throw a RangeError.
            zonedFormatter = new Intl.DateTimeFormat(options.locale, _object_spread_props(_object_spread({}, options), {
                timeZone: timeZone
            }));
            this.tzMap.set(key, zonedFormatter);
        }
        return zonedFormatter;
    };
    return DateTimeMissingFormat;
}(MissingFormatRange);

//# sourceMappingURL=DateTimeMissingFormat.js.map